export default __webpack_public_path__ + "static/media/copyright.cc3279ec.svg";